module.exports = __webpack_public_path__ + "img/logo-new.e86dbcc4.png";